import React from 'react';
import { Calendar } from 'lucide-react';

const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return dateString;
  }
};

export default function Tasks({ tasks = [], isDarkMode }) {
  const displayTasks = Array.isArray(tasks) ? tasks : [];

  if (displayTasks.length === 0) {
    return (
      <div className={`rounded-lg px-4 py-6 text-sm ${isDarkMode ? 'bg-slate-800/40 text-slate-400' : 'bg-white text-slate-600'}`}>
        No Tasks available right now
      </div>
    );
  }

  return (
    <div>
      <div className="space-y-2 overflow-x-auto">
        {displayTasks.map((task, idx) => {

          return (
            <div
              key={task.TaskID || idx}
              className={`grid min-w-[760px] grid-cols-5 gap-4 items-center px-4 py-4 rounded-lg transition-colors ${
                idx % 2 === 0
                  ? isDarkMode
                    ? 'bg-slate-800/50 hover:bg-slate-800'
                    : 'bg-white hover:bg-blue-50/50'
                  : isDarkMode
                    ? 'bg-slate-800/30 hover:bg-slate-800'
                    : 'bg-blue-50/20 hover:bg-blue-50/40'
              }`}
            >
              <div className={`col-span-2 min-w-0 truncate font-medium ${isDarkMode ? 'text-slate-200' : 'text-slate-800'}`}>
                {task.Title}
              </div>
              <div className={`whitespace-nowrap ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                {task.FocusAreaName}
              </div>
              <div className={`whitespace-nowrap font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                {task.DifficultyLevel || 'Medium'}
              </div>
              <div className={`flex items-center justify-end gap-2 whitespace-nowrap ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                <Calendar size={14} />
                {task.DueDate ? formatDate(task.DueDate) : 'N/A'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}